import React, { useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';

const EditPersonModal = ({ show, onHide, onEdit, clicledId, uid }) => {
    const [newName, setNewName] = useState('');
    const handleSubmit = (event) => {
        event.preventDefault();
        onEdit(uid, newName);
        onHide()
    };
    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Edit Person</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group>
                        <Form.Label>Full Name</Form.Label>
                        <Form.Control
                            type="text"
                            defaultValue={clicledId}
                            onChange={(event) => setNewName(event.target.value)}
                            required
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancel
                </Button>
                <Button variant="primary" disabled={newName === ''} type="submit" onClick={handleSubmit}>
                    Submit
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
export default EditPersonModal;
